import { render } from "./BackgroundSection.vue?vue&type=template&id=bd1da666"
import script from "./BackgroundSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BackgroundSection.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "C:\\laragon\\www\\agrifutura\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/frontend/components/BackgroundSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bd1da666"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bd1da666', __exports__)) {
    console.log('reload')
    api.reload('bd1da666', __exports__)
  }
  
  module.hot.accept("./BackgroundSection.vue?vue&type=template&id=bd1da666", () => {
    console.log('re-render')
    api.rerender('bd1da666', render)
  })

}


export default __exports__